export default __webpack_public_path__ + "static/media/hero-shape-2.fb495556.png";